import React from 'react';
import useAuth from '../hooks/useAuth';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import isValidTokenOperator from './isValidTokenOperator';

const RequireOperator = ({ children }) => {
    return isValidTokenOperator() ? (
        children
    ) : (
        <Navigate to="/dashboard/abstract-list" replace />
    );
};

RequireOperator.propTypes = {
    children: PropTypes.any,
};

export default RequireOperator;
